import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

import './ForgotPassword.css';
import { UpdateUserAPI } from '../../api/user.api'
axios.defaults.baseURL = process.env.REACT_APP_BRAVERMAN;
const apiUrl = process.env.REACT_APP_BRAVERMAN;
const ResetPassword = () => {
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const email = sessionStorage.getItem('email');
  const MySwal = withReactContent(Swal);

  const [validations, setValidations] = useState({
    length: false,
    upper: false,
    lower: false,
    number: false,
    special: false,
  });

  const navigate = useNavigate();

  const validatePassword = (password: string) => {
    setValidations({
      length: password.length >= 8,
      upper: /[A-Z]/.test(password),
      lower: /[a-z]/.test(password),
      number: /\d/.test(password),
      special: /[!@#$%^&*(),.?":{}|<>]/.test(password),
    });
  };

  const handlePasswordChange = (value: string) => {
    setNewPassword(value);
    validatePassword(value);
  };

  const isPasswordValid = Object.values(validations).every((v) => v);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setMessage('');
    if (!email || newPassword !== confirmPassword || !isPasswordValid) {
      setMessage('הסיסמה אינה תקינה או אימייל חסר.');
      return;
    }
    if (newPassword !== confirmPassword) {
      setMessage('הסיסמאות אינן תואמות.');
      return;
    }

    if (!isPasswordValid) {
      setMessage('הסיסמה אינה עומדת בכל הדרישות.');
      return;
    }

    try {

      const response = await axios.put(`${apiUrl}User/ResetPassword?email=${encodeURIComponent(email)}&newPassword=${encodeURIComponent(newPassword)}`);
      if (response.status === 200) {
        MySwal.fire({
          title: 'success',
          text: 'הסיסמה עודכנה בהצלחה',
          icon: 'success',
          confirmButtonText: 'אישור',
          customClass: {
            confirmButton: 'my-confirm-button'
          }
        });
        navigate('/login');
      } else {
        setMessage('שגיאה בעדכון הסיסמה.');
      }
    } catch (error) {
      setMessage('שגיאה בשרת. נסה שוב מאוחר יותר.');
    }
  };

  return (
    <div className="reset-container">
      <h2>צור סיסמה חדשה</h2>
      <form onSubmit={handleSubmit}>
        <div className="input-group">
          <label>בחר סיסמה:</label>
          <div className="password-input">
            <input
              type={!showPassword ? 'password' : ''}

              value={newPassword}
              onChange={(e) => handlePasswordChange(e.target.value)}
              required
            />
            <span
              onClick={() => setShowPassword(!showPassword)}
              className="toggle-visibility"
              title="הצג/הסתר סיסמה"
            >
              {showPassword ? '' : ''}
            </span>
          </div>
        </div>

        <ul className="password-rules">
          <li className={validations.length ? 'valid' : ''}>לפחות 8 תווים</li>
          <li className={validations.upper ? 'valid' : ''}>אות גדולה אחת לפחות (A-Z)</li>
          <li className={validations.lower ? 'valid' : ''}>אות קטנה אחת לפחות (a-z)</li>
          <li className={validations.number ? 'valid' : ''}>מספר אחד לפחות (0-9)</li>
          <li className={validations.special ? 'valid' : ''}>תו מיוחד אחד לפחות (!@#$...)</li>
        </ul>

        <div className="input-group">
          <label>אישור סיסמה:</label>
          <div className="password-input">
            <input
              type={showConfirmPassword ? 'text' : 'password'}
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
            />
            <span
              onClick={() => setShowConfirmPassword(!showConfirmPassword)}
              className="toggle-visibility"
              title="הצג/הסתר סיסמה"
            >
              {showConfirmPassword ? '' : ''}
            </span>
          </div>
        </div>

        <button type="submit">עדכן סיסמה</button>
      </form>

      {message && <p className="message">{message}</p>}
    </div>
  );
};

export default ResetPassword;
